import { createContext, useContext } from "react";

const PreviewContext = createContext(false);

export default PreviewContext;

export const useIsPreview = () => useContext(PreviewContext);
